import { Dropdown, Layout, theme, Badge, Popover, Form, Spin } from "antd";
import { useCallback, useEffect, useState } from "react";
import './topHeader.css';
import { logout } from '../../../modules/userManagement/auth/authSlice'
import { useDispatch, useSelector } from 'react-redux';
import { checkPermissions, pusherInitializer, decryptLocalData } from "@comps/commonFunctions"
import { SelectWithSearch } from "@comps/components";
import { NotificationOutlined, UserOutlined, LogoutOutlined, DownOutlined, MenuOutlined } from '@ant-design/icons';
import ViewProfile from '../../../modules/employeeManagement/companyEmployees/components/ViewProfile';

import { makeRequest } from '@utils/helpers';
import { countTopNotificationsReq } from "./requests";
import { notify } from '@utils/helpers';
import TopNotification from './TopNotification';
import { ShowErrorModal } from "../../../wrappers/components";
import { getJobResultErrors } from "../../../modules/common/requests";
import { getResourceDataReq, createSelectList } from "@comps/commonFunctions";
import _ from "lodash";
import JobProgressPopup from "../../../wrappers/layout/JobProgressPopup";

const { Header } = Layout;

const TopHeader = ({ isMobileViewport = false, mobileNavOpen = false, onToggleNavigation }) => {
  const [searchLoader, setSearchLoader] = useState(false);
  const [, setBackgroundLoader] = useState(false);
  const authUser = useSelector((state) => state.auth.authUser);
  const [employeesAll, setAllEmployees] = useState([]);
  const [childComponent, setChildComponent] = useState(null)
  const [notifications, setNotifications] = useState(null);
  const [notifyCount, setNotifyCount] = useState(null)
  const [empployments, setEmployments] = useState([]);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    countNotify();

  }, [])

  //end report
  const handleLogout = () => {
    dispatch(logout())
    window.location.replace('/');
  }

  useEffect(() => {
    const user = decryptLocalData('user');
    if (!user || !user.tenant) {
      return;
    }
    const pusher = pusherInitializer();
    const channel = pusher.subscribe(user.tenant);
    channel.bind('bell-notification-event', function (data) {
      if (data.data) {
        const decode = JSON.parse(data.data)
        if (decode.employment_id && decode.employment_id === user.employment_id) {
          notify(decode.message)
          countNotify()
        }
        else {
          countNotify()
        }
      }

    });
    // Cleanup function for unsubscribing and unbinding when the component is unmounted
    return () => {
      // Unbind the event handler
      channel.unbind('bell-notification-event');
      // Unsubscribe from the channel
      pusher.unsubscribe(user.tenant);
      // Disconnect from Pusher
      pusher.disconnect();
    };
    // eslint-disable-next-line
  }, [authUser]);

  //==========================Start Pusher=================================
  useEffect(() => {
    const user = decryptLocalData('user');
    if (!user || !user.tenant) {
      return;
    }
    const pusher = pusherInitializer();
    const channel = pusher.subscribe(user.tenant);
    channel.bind('shifts-created-event', function (res) {
      if (res.data.success) {
        //notify('Employees Shifts Created Successfully!')
      }
      else {
        if (res.employment_id === user.employment_id) {
          makeRequest(setBackgroundLoader, getJobResultErrors, res.data.id, onSuccessErrors, null);
        }

      }
    });
    // Cleanup function for unsubscribing and unbinding when the component is unmounted
    return () => {
      // Unbind the event handler
      channel.unbind('shifts-created-event');
      // Unsubscribe from the channel
      pusher.unsubscribe(user.tenant);
      // Disconnect from Pusher
      pusher.disconnect();
    };
    // eslint-disable-next-line
  }, [authUser]);

  const onSuccessErrors = (res) => {
    const errors = JSON.parse(res.errors)
    setChildComponent(<ShowErrorModal errors={ errors } module={ "Create Roaster" } onCompleted={ () => setChildComponent(null) } />)
  }
  //==========================end Pusher =================================


  //on select employee after search
  const onView = (id, isAuth) => {
    if (id) {
      const filterEmp = employeesAll.filter(each => each.id === id)
      let employeeId = null
      if (isAuth === true && authUser.employee_id) {
        employeeId = authUser.employee_id
      }
      else {
        employeeId = filterEmp.length > 0 ? filterEmp[0].employee_id : null
      }
      const record = { id: id, employee_id: employeeId }
      setChildComponent(<ViewProfile record={ record } disabled={ false } onCompleted={ onCompleted } />);
    }
  };
  const onCompleted = (data) => {

    if (!data) {
      setNotifications(null)
      setChildComponent(null)
      searchFrom.setFieldValue('employment_id', null);
    }
  }
  //===================notification start=======================================
  const getNotifications = () => {
    countNotify()
    setNotifications(<TopNotification onCompleted={ onCompleted } />)
  }

  const countNotify = () => {
    makeRequest(setBackgroundLoader, countTopNotificationsReq, null, onSuccessView, onError);
  }
  const onSuccessView = (res) => {
    setNotifyCount(res.count)
  }
  const onError = (res, err) => {
  }

  const handleProfileView = () => {
    setProfileMenuOpen(false);
    onView(authUser.employment_id, true);
  };

  const profileMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'View Profile',
      onClick: handleProfileView,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      danger: true,
      onClick: handleLogout,
    },
  ];

  const debouncedGetEmployees = useCallback(
    _.debounce((value) => {
      getEmployees(`search_|${value}`);
    }, 500),
    [] // Empty array ensures the function is created only once
  );
  const onSearchEmployee = (value) => {
    debouncedGetEmployees(value)
    //getEmployees(`search_|${value}`)
  }
  const getEmployees = (filters) => {
    if (authUser.role_id === 1 || authUser.role_id === 4) {

    } else {
      filters = `${filters};subordinate_|${authUser.employment_id}`;
    }
    let payload = {
      page: 1,
      type: 'employment',
      filters: filters
    }
    makeRequest(setSearchLoader, getResourceDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (response) => {
    setAllEmployees(response.resources.data)
    setEmployments(createSelectList(response.resources.data));
    setSearchLoader(false)
  }

  const onFocusEmployeeSearch = () => {
    if (empployments.length === 0) {
      getEmployees()
    }
  }

  // const handleSupportChat = () => {
  //   setChildComponent(<Assistant />);
  // }
  const [searchFrom] = Form.useForm();
  //==================notification ends=========================================
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <>
      <Header className="top-header-layout" style={ { background: colorBgContainer } }>
        <div className="top-header-main">
          { childComponent }

          { isMobileViewport ? (
            <button
              type="button"
              className={ `top-nav-toggle${mobileNavOpen ? ' top-nav-toggle--active' : ''}` }
              onClick={ onToggleNavigation }
              aria-label={ mobileNavOpen ? 'Close navigation menu' : 'Open navigation menu' }
              aria-expanded={ mobileNavOpen }
            >
              <MenuOutlined />
            </button>
          ) : null }

          { checkPermissions('dashboard', 'employmentSearch') ?
            <div className="top-search-container">
              <Form form={ searchFrom } name="searchFrom" className="top-search-form" style={ { marginBottom: 0 } }>
                <Spin spinning={ searchLoader }>
                  <Form.Item name={ 'employment_id' } style={ { marginBottom: 0 } }>
                    <SelectWithSearch options={ empployments } onSearch={ onSearchEmployee } style={ { width: '100%', borderRadius: 8, height: 42 } } searchEmployeeHeader={ true } setallemployees={ setAllEmployees } onChange={ onView } module="header" type="employment" placeholder="Search employee..." onFocus={ () => onFocusEmployeeSearch('') } />
                  </Form.Item>
                </Spin>
              </Form>
            </div>
            : null
          }
        </div>

        {/* Right Side: Notifications & User Profile */ }
        <div className="header-right-actions">

          <div className="notification-wrapper">
            <JobProgressPopup />
          </div>

          <div className="notification-wrapper">
            <Popover content={ notifications } title="Notifications" trigger="click" placement="bottomRight" onClick={ () => getNotifications() }>
              <Badge size="small" count={ notifyCount } color="#ff3c00" offset={ [2, 2] }>
                <div className="notification-icon-btn">
                  <NotificationOutlined style={ { fontSize: 20, color: '#0F1B3D' } } />
                </div>
              </Badge>
            </Popover>
          </div>

          <Dropdown
            menu={ { items: profileMenuItems } }
            trigger={ ['click'] }
            placement="bottomRight"
            open={ profileMenuOpen }
            onOpenChange={ setProfileMenuOpen }
            overlayClassName="profile-dropdown-menu"
          >
            <div
              className="user-profile-btn"
            >
              <div className="user-profile-copy">
                <span className="user-profile-name">{ authUser.full_name + '-' + authUser.code }</span>
                {/* <span className="user-profile-name">{ authUser.email }</span> */ }
                <span className="user-profile-role">{ authUser.role_name || '' }</span>
              </div>
              <img
                className="user-profile-avatar"
                width={ 40 }
                height={ 40 }
                src={ authUser.profile_pic_url !== "images/arnold-avatar.jpg" ? authUser.profile_pic_url : "/images/arnold-avatar.jpg" }
                alt="User"
              />
              <DownOutlined
                className={ `user-profile-caret${profileMenuOpen ? ' user-profile-caret--open' : ''}` }
              />
            </div>
          </Dropdown>

        </div>
      </Header>
    </>
  )
}

export default TopHeader;
